var map = {
	"./data.js": 55303,
	"./education.js": 87052,
	"./home.js": 57359,
	"./internal.js": 5712,
	"./sale.js": 70438,
	"./school.js": 47338,
	"./setting.js": 78741,
	"./student.js": 15307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21600;